<template>
    <div id="wmss">
    <div class="c"></div>
    <div id="bd">
        <!-- <div id="ban-in" class="bannerImg" >
            <div class="ban-bg"></div>
        </div> -->
        <div class="wp" >
            <div class="tit-i">
                <h3>我们是谁</h3>
                <h5>about <span>SYQJ.TECH</span></h5>
            </div>
            <div class="c"></div>
            <div class="about-info" >
                <p> 沈阳千极软件有限公司成立于2022年（前身沈阳信正软件有限公司），注册资金1000万元;</p>
                <p> 是一家隶属于沈阳市浑南高新技术产业区、专注国内住房公积金行业管理信息化的双软认定企业;</p>
                <p> 具有自主研发软件著作权达30项。本着“致力创新、服务民生”的企业理念;</p>
                <p> 为住房公积金管理中心打造“以客户为中心、服务驱动的数字智慧公积金”行业私有云解决方案;</p>
                <!-- <p> 沈阳千极科技有限公司是一家专业从事计算机软件开发和应用的高新科技企业;</p>
                <p>以高科技产品的研发、技术服务及系统解决方案咨询为主攻方向，坚持走自主创新、稳步发展之路；</p>
                <p>以打造“千极”品牌为基本策略，以产品自身的品质、先进的技术和良好的服务取信于用户；</p>
                <p>公司从事政府行业，并有8年以上的行业经验；</p>
                <p>公司以人才为本，注重品行、态度、能力与业绩，能够为员工提供充分发挥个人潜能和实现自我价值的发展空间。</p> -->
            </div>
        </div>
        <div class="wp" id="zscq">
        <div class="tit-i">
                <h3>知识产权</h3>
                <h5>IPR <span>SYQJ.TECH</span> </h5>
            </div>
            <div class="c"></div>
            <div class="zscq-box">
                <img src="../assets/Images/ZSCQ.jpg">
                <!-- <div class="zscq-imgtxt">
                    描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述
                    描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述
                    描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述
                    描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述
                </div> -->
            </div>
            <ul class="ul-case">
                <li>
                    <router-link to="">
                        <div class="block">
                            <div class="pic">
                                <img src="../assets/Images/1.jpg">
                            </div>
                        </div>
                    </router-link>
                    <div class="zscq-txt">
                        <p class="zscq-title">千极运行监控系统V5.0</p>
                        <!-- <span class="zscq-line"></span>
                        <div class="c"></div>
                        <p class="zscq-info">以高科技产品的研发、技术服务及系统解决方案咨询为主攻方向，坚持走自主创新、稳步发展之路；</p> -->
                    </div>
                </li>
                <li>
                    <router-link to="">
                        <div class="block">
                            <div class="pic">
                                <img src="../assets/Images/2.jpg">
                            </div>
                        </div>
                    </router-link>
                    <div class="zscq-txt">
                        <p class="zscq-title">千极个人贷款管理系统V5.0</p>
                        <!-- <span class="zscq-line"></span>
                        <div class="c"></div>
                        <p class="zscq-info">以高科技产品的研发、技术服务及系统解决方案咨询为主攻方向，坚持走自主创新、稳步发展之路；</p> -->
                    </div>
                </li>
                <li>
                    <router-link to="">
                        <div class="block">
                            <div class="pic">
                                <img src="../assets/Images/3.jpg">
                            </div>
                        </div>
                    </router-link>
                    <div class="zscq-txt">
                        <p class="zscq-title">千极人民银行征信前置系统V5.0</p>
                        <!-- <span class="zscq-line"></span>
                        <div class="c"></div>
                        <p class="zscq-info">以高科技产品的研发、技术服务及系统解决方案咨询为主攻方向，坚持走自主创新、稳步发展之路；</p> -->
                    </div>
                </li>
            </ul>
        </div>
        <div class="row4 fix" id="lxwm">
            <div class="wp">
                <div class="tit-i">
                    <h3>联系我们</h3>
                    <h5>contact <span>SYQJ.TECH</span></h5>
                </div>
                <div class="contact-l">
                    <ul class="ul-contact">
                        <li class="li1">辽宁省沈阳市浑南区上深沟村863-9号沈阳国际软件园内D09号楼410房间</li>
                        <li class="li2">
                            <a href="tel:13500000000">13889139023</a><br />
                            <!-- <a href="tel:4008-888-888">4008-888-888 (咨询)</a> -->
                        </li>
                        <li class="li3">
                            <a href="mailto:syqj@syqj.tech">syqj@syqj.tech</a>
                        </li>
                        <!-- <li class="li4">
                            <a href="mailto:admin@admin.cn">admin@admin.cn</a>
                        </li> -->
                    </ul>
                </div>
                <div class="contact-r">
                    <!-- <form action="/plus/diy.php" class="contact-form" enctype="multipart/form-data" method="post">
                        <input type="hidden" name="action" value="post" />
                        <input type="hidden" name="diyid" value="1" />
                        <input type="hidden" name="do" value="2" />
                        <div class="">
                            <input type="text" class="inp l" name="name" id="name" placeholder="您的姓名">
                            <input type="text" class="inp r" name="tel" id="tel" placeholder="您的联系方式">
                        </div>
                        <textarea cols="30" rows="10" name="nr" id="nr"></textarea>
                        <input type="hidden" name="dede_fields" value="name,text;tel,text;nr,text" />
                        <input type="hidden" name="dede_fieldshash" value="1150bc325e255641e2db4115e8c9c51f" />
                        <a class="sub"  @click="subform()" style="display:block">提交您的需求</a>
                    </form> -->
                    <div  style="width:100%;height:500px;border:#ccc solid 1px;float:right" id="map"></div>
                </div>
            </div>
        </div>
        <div class="h50"></div>
    </div>
    <!-- end #bd -->
</div>
</template>
<style>
/* .bannerImg {
  background-image: url(../assets/Images/14415953225349.jpg);
} */
</style>
<script type="text/javascript" src="http://api.map.baidu.com/api?v=2.0&ak=5b31afcdea6af2d7d3677ca5c1a22c46"></script>
<script>
import {MP} from '../assets/Scripts/ditu.js'
import {initMap} from '../assets/Scripts/map.js'
import '../assets/Scripts/lib.js'
import '../assets/Scripts/flexslider.js'
import {flexslider} from '../assets/Scripts/banner.js'


    export default {
        name: "",
        data() {
            return {
            };
        },
        created(){
            this.$nextTick(function(){//百度api加载完成执行
                var _this = this;
                MP().then(BMap => {
                    initMap();
                // 百度地图API功能
                }).catch(BMap=>{
                    console.log(BMap)
                })
            })
        },mounted(){
            setTimeout(() => {
                // console.log($.isEmptyObject(this.$route.params))
                if(!$.isEmptyObject(this.$route.params)){
                    document.querySelector("#"+this.$route.params.id).scrollIntoView(true);  
                }
            }, 100);
            initMap()
            $('.ul-icon-i li').hover(function(){
            $(this).find('img:first').fadeIn(100);
            $(this).find('.pic-icon').animate({top:0});
            },function(){
            $(this).find('.pic-icon').animate({top:-134});
            $(this).find('img:first').fadeOut(100);
            })
            //最新动态动画效果
            $('.ul-news-i li').hover(function(){
                $(this).toggleClass('on');
            })
            $('.case-img').hover(function(){
                $(this).toggleClass('on');
            })
            //地图效果
            $('.map .btn').click(function(){
            $('.map-pop').show();
            $(this).parents('.map').addClass('map-big-i');
            var winW = $(window).width();
            var winH = $(window).height();
            console.log(winH);
            if(winW < 768){
            $('.map-pop').height($(window).height()-50-80);
            $('.map-big-i').height($(window).height()-50-80);
            $("html, body").animate({ scrollTop: $(document).height() }, 1000);
            }else{

            $('.map-pop').height($(window).height()-344);
            $('.map-big-i').height($(window).height()-344);
            $("html, body").animate({ scrollTop: $(document).height() }, 1000);
            }
                initMap();
            })
            $('.map .btn-down').click(function(){
                $('.map-pop').hide();
                $(this).parents('.map').removeClass('map-big-i');
                $('.map').height('107');
            })
           
        },
        methods:{
            subform(){
                if($('#name').val()==''){alert("请输入姓名！");return false;}
                if($('#tel').val()==''){alert("请输入电话！");return false;}
                if($('#nr').val()==''){alert("请输入内容！");return false;}
                return;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/lxwm.vue